import React from 'react'
import { observer } from 'mobx-react'
import PropTypes from 'prop-types'

import Tooltip from '@components/Tooltip'

const ProjectItemStats = ({ project }) => {
  const stats = [
    { name: 'Requested experts', value: project.required },
    { name: 'Target number of interviews', value: project.interviewTarget },
    { name: 'Submitted experts', value: project.delivered },
    { name: 'Experts interviewed', value: project.interviewed }
  ]
  return (
    <div className='my-project-item--stats'>
      {stats.map(stat => (
        <div key={stat.name}>
          <Tooltip tooltip={stat.name}>
            <span>{stat.value}</span>
          </Tooltip>
        </div>
      ))}
    </div>
  )
}

ProjectItemStats.propTypes = {
  project: PropTypes.object
}

export default observer(ProjectItemStats)
